import { connect } from "react-redux";

import { provideLocationState } from "components/utility/hoc/LocationState";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var Spinner = require("components/utility/Spinner");
var CopyTextInput = require("components/utility/CopyTextInput");
var Glyphicon = require("components/utility/icons/Glyphicon");
var DiffDisplay = require("components/utility/DiffDisplay");

var BookDisplay = require("components/reading/books/BookDisplay")

var DataActions = require("lib/actions/DataActions");
var DataSelectors = require("lib/selectors/DataSelectors");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var ClassResultsRouting = require("lib/routing/ClassResultsRouting");
var StudentDisplay = require("components/users/students/StudentDisplay");

var CurrentUser = require("lib/account/CurrentUser");

require("data/class_results_page.scss");

// Provide location state first, since we may want to access the school ID
@provideLocationState(ClassResultsRouting.getRouteState)
@connect(
	(state, props) => {
		var downProps = {};

		var query = ClassResultsRouting.getQuery(props.locationState);
		downProps.report = DataSelectors.report({ state, query });
		downProps.loading = DataSelectors.isLoadingReport({ state, query });

		// This is here to make sure updateState is called when book titles load in
		downProps.totalTextCount = ReadingSelectors.books({ state });

		return downProps;
	},

	(dispatch, props) => ({
		populateData: () => {
			var query = ClassResultsRouting.getQuery(props.locationState);

			return dispatch(DataActions.fetchReport({
				query, cache: true
			}))
		}
	})
)

@providePopulateData()
class ClassResultsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.wrap = React.createRef();
	}

	toggleHideNames() {
		var hideNames = !this.props.locationState.hideNames;

		$wr.redirect(ClassResultsRouting.getPath(
			_.extend({}, this.props.locationState, { hideNames })
		));
	}

	hideNames() {
		return this.props.locationState.hideNames;
	}

	renderShareSection() {
		return (
			<div className="shareSection hideOnPrint">
				<div className="shareLink">
					Share Link: <CopyTextInput text={ window.location.href } />
				</div>
				<div className="printLink">
					<a href="#" onClick={ $wr.print }>
						<Glyphicon icon="print" /> Print Report
					</a>
				</div>
				<div className="hideStudents">
					<label className="normal">
						<input type="checkbox" checked={ !this.props.locationState.hideNames }
							onChange={ this.toggleHideNames } /> Show Student Names
					</label>
				</div>

			</div>
		);
	}

	renderBestAnswer() {
		var answer = this.props.report.best_answer;
		if (!answer) {
			return (<div className="bestAnswer" />);
		}

		var answerParagraphs = _.map(answer.body.split("\n"), (text, index) => {
			return (
				<p key={ index }>
					{ text }
				</p>
			);
		});

		return (
			<div className="bestAnswer">
				<p className="reportSubHeader">Best Answer</p>

				<div className="studentTextPair clearfix">
					<BookDisplay textID={ answer.text_id } />
					<StudentDisplay studentID={ answer.user_id } firstNameLastInitial
						showAvatar hideName={ this.hideNames() } avatarMaxWidth={ 50 } />
				</div>

				<p>
					<strong>{ answer.question_text }</strong>
				</p>
				{ answerParagraphs }
			</div>
		);
	}

	renderTopTexts() {
		if (!this.props.report.texts) {
			return (<div className="topTexts" />);
		}

		var textDisplays = _.map(this.props.report.texts.top, (text) => {
			return (
				<li key={ text.text_id } className="topTitle">
					<BookDisplay textID={ text.text_id } />
					<span className="readCount">({ text.user_count }x)</span>
				</li>
			);
		});
		return (
			<div className="topTexts">
				<p className="reportSubHeader">Top Books</p>
				<ol>
					{ textDisplays }
				</ol>
			</div>
		);
	}

	renderFeedbackCorrection() {
		var revision = this.props.report.best_revision;
		if (!revision) {
			return (<div className="feedbackCorrection" />);
		}

		return (
			<div className="feedbackCorrection">
				<p className="reportSubHeader">Improving from Owlfonso's Feedback</p>
				
				<div className="studentTextPair clearfix">
					<BookDisplay textID={ revision.text_id } />
					<StudentDisplay studentID={ revision.user_id } firstNameLastInitial
						showAvatar hideName={ this.hideNames() } avatarMaxWidth={ 50 } />
				</div>

				<div className="feedbackRow">
					<div className="rowLabel">
						Question:
					</div>
					<div className="content">
						{ revision.question }
					</div>
				</div>

				<div className="feedbackRow">
					<div className="rowLabel">
						Before:
					</div>
					<div className="content">
						{ revision.revision.source }
					</div>
				</div>

				<div className="feedbackRow">
					<div className="rowLabel">
						Feedback:
					</div>
					<div className="content">
						{ revision.revision.feedback_content }
					</div>
				</div>

				<div className="feedbackRow">
					<div className="rowLabel">
						After:
					</div>
					<div className="content">
						<DiffDisplay text={ revision.revision.diff } />
					</div>
				</div>
			</div>
		);
	}

	renderAggregateStats() {
		var report = this.props.report;

		if (report.aggregate_stats.minutes_read) {
			var varStat = (
				<div className="stat">
					<div className="num">
						{ report.aggregate_stats.minutes_read }
					</div>
					<div className="numLabel">
						Minutes
					</div>
				</div>

			);
		} else {
			var varStat = (
				<div className="stat">
					<div className="num">
						{ report.aggregate_stats.writing_count }
					</div>
					<div className="numLabel">
						All Writing
					</div>
				</div>
			);
		}

		return (
			<div className="collectiveStats">
				<div className="stat">
					<div className="num">
						{ report.aggregate_stats.quiz_count }
					</div>
					<div className="numLabel">
						Quizzes
					</div>
				</div>
				<div className="stat">
					<div className="num">
						{ report.aggregate_stats.answers_count }
					</div>
					<div className="numLabel">
						Answers
					</div>
				</div>
				<div className="stat">
					<div className="num">
						{ report.aggregate_stats.reviews_count }
					</div>
					<div className="numLabel">
						Reviews
					</div>
				</div>
				{ varStat }
				<div className="stat">
					<div className="num">
						{ report.texts.text_count }
					</div>
					<div className="numLabel">
						Books Read
					</div>
				</div>
			</div>
		);
	}

	renderMostImproved() {
		var scoreCap = 4
		var improvedStudents = _.map(this.props.report.most_improved, (improvement, index) => {

			var imgPath = "ranks/school-comp-medal-" + (index + 1) + "-basic.png";
			var rankingImg = (
				<img className="rankImg" src={ dynamicRequire(imgPath) }></img>
			);

			var change = Math.round(10 * scoreCap * improvement.change) / 10;

			return (
				<div className="improvedStudent" key={ improvement.user_id }>
					<p className="reportSubHeader">
						{ rankingImg } Most Improved
					</p>
					<div>
						<StudentDisplay studentID={ improvement.user_id }
							firstNameLastInitial showAvatar hideName={ this.hideNames() }
							avatarMaxWidth={ 50 } />
							{ " " }(+{ change } points)
					</div>
				</div>
			);
		});


		if (improvedStudents.length > 0) {
			var mostImprovedReport = (
				<div className="mostImproved">
					{ improvedStudents }

					<p className="explanation">
						Based on change in students' scores (out of { scoreCap })
						from the start to the end of the year.
					</p>
				</div>
			)
			return mostImprovedReport;
		}
	}

	render() {
		if (this.props.loading) {
			var content = (
				<Spinner placeholder={ true } scale={ 1.7 } />
			);

		} else if (!this.props.report) {
			var content = (
				<p>No report found... you may have been sent to this page by accident.</p>
			);
		} else {
			var teacherName = this.props.report.teacher_name;

			var currentUser = CurrentUser.get();
			var shareContent = (currentUser && (this.props.report.user_id == currentUser.id)) ? this.renderShareSection() : "";
			var content = (
				<div>
					{ shareContent }
					<div className="topSection clearfix">
						<div className="left">
							{ this.renderBestAnswer() }
						</div>
						<div className="right">
							{ this.renderTopTexts() }
						</div>
					</div>
					{ this.renderFeedbackCorrection() }
					{ this.renderAggregateStats() }
					{ this.renderMostImproved() }
				</div>
			)
		}

		return (
			<div className="container classResultsPage" ref={ this.wrap }>
				<header className="pageHeader">
					<h1>Teacher Reports</h1>
					<p className="teacherName">{ teacherName }</p>
				</header>

				{ content }

			</div>
		);
	}

	componentDidUpdate(prevProps) {
		var reportLock;
		if (this.props.report) {
			reportLock = this.props.report.lock;
		}

		if (reportLock != this.props.locationState.reportLock) {
			$wr.redirect(ClassResultsRouting.getPath(
				_.extend({}, this.props.locationState, { reportLock })
			));

		} else if (!_.isEqual(_.omit(prevProps.locationState, "report_lock"),
			_.omit(this.props.locationState, "report_lock"))) {

			this.props.populateData();
		}

		this.adjustVisibleTitles();

	}

	adjustVisibleTitles() {
		var $topTitles = $(this.wrap.current).find("li.topTitle");
		var $titleSection = $(this.wrap.current).find(".topTexts");
		var $answerSection = $(this.wrap.current).find(".bestAnswer");

		var MIN_TITLES = 3;
		var MARGIN = 20;

		$topTitles.show();

		function removeOne() {
			var leftHeight = $answerSection.height();
			var rightHeight = $titleSection.height();
			var $visibleTitles = $topTitles.filter(":visible");

			if ((leftHeight + MARGIN < rightHeight) && ($visibleTitles.length > MIN_TITLES)) {
				$visibleTitles.last().hide();
				setTimeout(removeOne, 10);
			}
		}

		removeOne()
	}
};

ClassResultsPage.WrappedComponent.propTypes = PageStrictPropTypes({
	locationState: PropTypes.object,

	// @connect data
	report: PropTypes.object,
	loading: PropTypes.bool,
	totalTextCount: PropTypes.number,

	// @connect handlers
	populateData: PropTypes.func
});

module.exports = ClassResultsPage;


// WEBPACK FOOTER //
// ./modules/components/data/ClassResultsPage.js